import {useEffect, useState} from "react";



function Profile (props) {

    const [profile, setProfile] = useState([]);

    const ticker = props.ticker;
  
    function fetchProfile(url)  {
    
        const abortCtrl   = new AbortController();
    
        const fetchData= async () => {
              console.log("fetch profile... "); 
              try {
                  const response = await fetch(url,{signal: abortCtrl.signal});
                  const json = await response.json();
                  setProfile(json);
                  console.log("fetch profile done");  
              } catch (error) {
                  if (error.name === 'AbortError'){
                      console.log("aborted", error);
                  }
                  else {
                      console.log("error", error);
                  }
              }
        };
      
        fetchData();
      
        return () => abortCtrl.abort();
      }


      useEffect(() => {
    
        const server="https://app.cuetraders.com";
        let url = server+"/api/load_profile.php?ticker="+ticker;
        fetchProfile(url);
    
    
      }, [ticker]);

      return (<div className="Profile">  {profile &&
        <div className="col-lg-12 col-sm-7 col-xs-12">
        <h4> Profile</h4>
        <div className="h5">{profile.CompanyName}</div>

            <p className="description">{profile.Description}</p>
        
                <p> </p>
          <div className="col-lg-6 col-sm-6 col-xs-6">  
          <ul>
            <li><i className="fa news">Address:</i> <i className="news-headline">{profile.Address}</i></li>
            <a href={profile.OfficialSite}>Website: {profile.OfficialSite}</a>
          </ul>
          </div>
          <div className="col-lg-6 col-sm-6 col-xs-6">  
          <ul>
            <li><i className="fa news">Exchange:</i> <i className="news-headline">{profile.Exchange}</i></li>
            <li><i className="fa news">Sector:</i> <i  className="news-headline">{profile.Sector}</i></li>
            <li><i className="fa news">Industry:</i> <i  className="news-headline">{profile.Industry}</i></li>
          </ul>
          </div>
      </div>}
    </div>)
}

export default Profile;